import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiShield, FiSearch, FiFileText, FiRefreshCw, FiSettings, FiClock } = FiIcons;

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FiShield,
      translationKey: 'consent'
    },
    {
      icon: FiSearch,
      translationKey: 'scanner'
    },
    {
      icon: FiFileText,
      translationKey: 'google'
    },
    {
      icon: FiRefreshCw,
      translationKey: 'scans'
    },
    {
      icon: FiSettings,
      translationKey: 'banner'
    },
    {
      icon: FiClock,
      translationKey: 'blocking'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium mb-4 inline-block">
            {t('features.badge')}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {t('features.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('features.description')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.translationKey}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="bg-blue-100 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="text-2xl text-blue-500" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {t(`features.items.${feature.translationKey}.title`)}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t(`features.items.${feature.translationKey}.description`)}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;